module.exports = __webpack_public_path__ + "img/characterAnime1.bdf4cc59.png";